
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#002823"}},[_c('path',{attrs:{"d":"M10 3.326a.39.39 0 00.39-.39V.978a.39.39 0 00-.78 0v1.958c0 .215.172.39.39.39zM5.243 4.194c.077.077.175.113.276.113s.2-.04.277-.113a.389.389 0 000-.55L4.413 2.262a.389.389 0 00-.55.55zM14.48 4.307a.4.4 0 00.276-.113l1.383-1.383a.389.389 0 00-.55-.55l-1.382 1.384a.389.389 0 00.273.662zM18.24 12.084v3.98a.39.39 0 01-.246.362l-7.604 2.986v-6.83l.891 1.164c.219.296.569.476.939.476.147 0 .292-.028.424-.082zM9.775 12.367c-.101 1.153-.163 4.91-.167 7.04L2.01 16.425a.39.39 0 01-.245-.363v-3.979L7.11 14.05l.035.012.21.078c.132.054.276.082.424.082.37 0 .716-.18.926-.46z"}}),_c('path',{attrs:{"d":"M19.642 10.187l-1.994-2.406a.072.072 0 00-.024-.016c-.023-.027-.05-.047-.077-.067l-.047-.023c-.012-.004-.023-.012-.034-.016l-7.348-2.312a.353.353 0 00-.237 0L2.533 7.659c-.011.004-.023.012-.034.016l-.047.023a.578.578 0 00-.077.062c-.009.009-.016.012-.024.02L.357 10.186a.387.387 0 00.164.611l7.122 2.617c.043.02.09.027.136.027a.382.382 0 00.308-.156L10 10.79l1.912 2.496c.074.102.191.156.308.156a.333.333 0 00.136-.027l7.122-2.616a.38.38 0 00.242-.261.37.37 0 00-.079-.35zm-9.64-.444L4.003 8.014l5.997-1.888 5.997 1.888z"}})])])
          )
        }
      }
    